import React from "react";
import styled, { css } from "styled-components";
import { IconButton } from "@material-ui/core";
import {
    ArrowBack as BackIcon,
    ArrowForward as ForwardIcon,
    Add as AddIcon,
    Fullscreen as FullscreenIcon
} from "@material-ui/icons";
import { incrementStartDate, setWeekCount } from "./actions";
import { useDispatch, useSelector } from "react-redux";
import { selectWeekCount } from "./selectors";

interface IIconButtonContainer {
    column: number;
}
export const IconButtonContainer = styled.div<IIconButtonContainer>`
    grid-column-start: ${props => props.column};
    grid-column-end: ${props => props.column};
    max-width: 20px;
    max-height: 20px;
    color: white;
    padding: 5px;
`;

const IconStyles = css`
    max-width: 20px;
    max-height: 20px;
    color: white;
`;

const StyledBackIcon = styled(BackIcon)`
    ${IconStyles}
`;

const StyledForwardIcon = styled(ForwardIcon)`
    ${IconStyles}
`;

const StyledFullscreenIcon = styled(FullscreenIcon)`
    ${IconStyles}
`;

export const StyledAddIcon = styled(AddIcon)`
    ${IconStyles}
`;

export const StyledIconButton = styled(IconButton)`
    && {
        width: 22px;
        height: 22px;
    }
`;

const ControlCellContainer = styled.div`
    grid-template-rows: 1fr;
    grid-template-columns: 0.5fr 1fr 0.5fr 0.5fr 0.5fr;
    grid-row-start: 2;
    grid-row-end: 2;
    grid-column-start: 1;
    grid-column-end: 1;
    display: grid;
    /* padding: 5px; */
`;

const Select = styled.select`
    border: none;
    height: 19px;
    width: 100%;
    border-radius: 2px;
    font-size: 12px;
    appearance: none;
    text-align: center;
    text-align-last: center;
    margin-top: 8px;
    grid-column: 2;
    grid-row: 1;
`;

interface IControlCellProps {
    setAddTrackModalOpen(state: boolean): void;
    setIsFull(state: boolean): void;
    isFull: boolean;
}

export const ControlCell = (props: IControlCellProps) => {
    const dispatch = useDispatch();
    const weekCount = useSelector(selectWeekCount);
    return (
        <ControlCellContainer>
            <IconButtonContainer column={1}>
                <StyledIconButton
                    onClick={() => props.setAddTrackModalOpen(true)}
                >
                    <StyledAddIcon />
                </StyledIconButton>
            </IconButtonContainer>
            <Select
                onChange={e => dispatch(setWeekCount(parseInt(e.target.value)))}
                value={weekCount}
            >
                <option value={1}>1 Week</option>
                <option value={2}>2 Weeks</option>
            </Select>

            <IconButtonContainer column={3}>
                <StyledIconButton
                    onClick={() => dispatch(incrementStartDate(-1))}
                >
                    <StyledBackIcon />
                </StyledIconButton>
            </IconButtonContainer>
            <IconButtonContainer column={4}>
                <StyledIconButton
                    onClick={() => dispatch(incrementStartDate(1))}
                >
                    <StyledForwardIcon />
                </StyledIconButton>
            </IconButtonContainer>
            <IconButtonContainer column={5}>
                <StyledIconButton onClick={e => props.setIsFull(!props.isFull)}>
                    <StyledFullscreenIcon />
                </StyledIconButton>
            </IconButtonContainer>
        </ControlCellContainer>
    );
};
